module.exports = (methodName, method) => {
    const staticVersionArity = method.length + 1;
    const recurry = (...parameters) => {
        if (parameters.length < staticVersionArity) {
            return (...additionalParameters) => {
                return recurry(...parameters.concat(additionalParameters));
            };
        }
        const instance = parameters[staticVersionArity - 1];
        parameters.splice(staticVersionArity - 1, 1);
        return (instance[methodName] || method).call(instance, ...parameters);
    };
    return recurry;
};
